<template>
  <div
    class="modal fade"
    id="hospital-acc-modal"
    tabindex="-1"
    aria-labelledby="hospital-acc-modal-label"
    aria-hidden="true"
    style="overflow-x: hidden"
  >
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" style="max-width: 460px !important;">
      <div class="modal-content certi-modal-border-radius" style="text-align: center;">
        <div 
          class="modal-header text-left" 
        >
          <div class="modal-header-flex">
            <h1 class="modal-title" id="staticBackdropLabel">
              병원 접속 관리
            </h1>
          </div>
        </div>
        <div class="modal-body text-center">
          <div class="modal-div-wrap">
            <div class="modal-input-div">
              <div class="label-wrap">
                <label for="">IP</label>
              </div>
              <input 
              type="text"
              disabled
              :value="selectedAccountInfo.ip || '-'"
              />
            </div>
            <div class="modal-input-div">
              <div class="label-wrap">
                <label for="">접속 기기</label>
              </div>
              <input 
              type="text"
              disabled
              :value="selectedAccountInfo.agent || '-'"
              />
            </div>
            <div class="modal-input-div">
              <div class="label-wrap">
                <label for="">최근 접속 시각</label>
              </div>
              <input 
              type="text"
              disabled
              :value="convertDateTime(selectedAccountInfo.lastLoginAt) || '-'"
              />
            </div>
            <div class="modal-input-div">
              <div class="label-wrap">
                <label for="">최초 접속 시각</label>
              </div>
              <input 
              type="text"
              disabled
              :value="convertDateTime(selectedAccountInfo.firstLoginAt) || '-'"
              />
            </div>
            <div class="modal-input-div">
              <div class="label-wrap">
                <label for="">로그인 됨</label>
              </div>
              <input 
                type="text"
                disabled
                :value="computedIsLoggedIn"
              />
              <button 
                class="logout-btn btn-hover" :class="selectedAccountInfo.isLoggedIn ? '' : 'disabled'"
                @click="logoutUser"  
              >
                로그아웃
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { convertDateTime } from '@/utils/utils';
export default {
  data() {
    return {
      convertDateTime,
      ip: '',
      agent: '',
      lastLoginAt: '',
      firstLoginAt: '',
      refreshToken: '',
      isLoggedIn: false,
    };
  },
  computed: {
    computedIsLoggedIn() {
      if(!this.selectedAccountInfo.isLoggedIn) return '로그아웃 됨';
      return '로그인 됨';
    },
  },
  props: {
    selectedAccountInfo: {
      ip: {
        type: String,
        required: false,
      },
      agent: {
        type: String,
        required: false,
      },
      lastLoginAt: {
        type: String,
        required: false,
      },
      firstLoginAt: {
        type: String,
        required: false,
      },
      refreshToken: {
        type: String,
        required: false,
      },
      username: {
        type: String,
        required: false,
      },
      companyId: {
        type: String,
        required: false,
      },
      isLoggedIn: {
        type: Boolean,
        required: false,
      }
    },
  },
  methods: {
    async logoutUser() {
      if(!this.selectedAccountInfo.isLoggedIn) return;
      const obj = {};
      obj.companyId = this.selectedAccountInfo.companyId;
      obj.username = this.selectedAccountInfo.username; 
      this.$emit('logoutUser', obj);
    },
  },
};
</script>
<style scoped>
.modal-div-wrap .modal-input-div {
  display: flex;
  gap: 10px;
  
}

button {
  border: none !important;
}

.modal-dialog .modal-content .modal-header {
  padding: 0px 14px 0px 20px !important;
  border-bottom: 1px solid rgba(0,0,0,0.1) !important;
  height: 52px !important;
  display: flex;
  align-items: center;
  
}

.modal-title {
  display: flex;
  font-size: 20px;
}
.modal-div-wrap .modal-input-div label{
  width: 110px;
}

.modal-dialog .modal-content .modal-body {
  padding-bottom :20px;
}
.modal-div-wrap {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.modal-input-div {
  padding: 0px !important;
}

.logout-btn {
  height: 40px;
  padding: 0 20px;
  border-radius: 8px;
  background-color: #2F3337;
  white-space: pre;
  color: white;
}

.logout-btn.disabled {
  opacity: 0.4;
}
</style>
